<template>
  <div class="selection-group">
    <BaseTradeInVoucherSelectionItem
      v-for="option in options"
      :key="option.code"
      :label="option.code"
      :isMatchBranch="option.valid"
      :branchName="option.branch_name"
      :amount="option.amount"
      :selected="value.includes(option.code)"
      :disabled="isDisabled(option)"
      @click="onToggle(option)"
    />
  </div>
</template>

<script>
import BaseTradeInVoucherSelectionItem from './BaseTradeInVoucherSelectionItem.vue'

export default {
  name: 'BaseTradeInVoucherSelectionGroup',

  components: {
    BaseTradeInVoucherSelectionItem,
  },

  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    selectedBranch() {
      const selectedOption = this.options.find(option =>
        this.value.includes(option.code),
      )

      return selectedOption?.branch ?? null
    },
  },

  methods: {
    isDisabled(option) {
      return (
        option.valid ||
        (this.selectedBranch !== null &&
          option.branch !== this.selectedBranch &&
          !this.value.includes(option.code))
      )
    },

    onToggle(option) {
      const isSelected = this.value.includes(option.code)
      const nextValue = isSelected
        ? this.value.filter(code => code !== option.code)
        : [...this.value, option.code]

      this.$emit('input', nextValue)
    },
  },
}
</script>

<style lang="stylus" scoped>
.selection-group {
    display: flex;
    flex-direction: column;

    ::v-deep .selection-item {
        &:first-of-type {
            border-radius: 8px 8px 0 0;
        }

        &:last-of-type {
            border-radius: 0 0 8px 8px;
        }

        &:first-of-type:last-of-type {
            border-radius: 8px;
        }

        &:not(:last-of-type) {
			border-bottom-color: transparent;
        }
    }
}
</style>
